import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../../css/shared/Sidenav.css';
import { AES, enc } from 'crypto-js';
const Sidenav = props => {
    const [isSystemConfig, setIsSystemConfig] = useState(false)
    const systemConfigdrop = true
    const tile = [
        {
            "imgSrc": require('../../assets/images/menu_advertisement_default.svg'),
            "hoverImgSrc": require('../../assets/images/menu_advertisement_hoverActive.svg'),
            "title": "Advertisement",
            "destPage": "/Advertisement",
            "id": 15
        },
        {
            "imgSrc": require('../../assets/images/menu_announcement_default.svg'),
            "hoverImgSrc": require('../../assets/images/menu_announcement_hoverActive.svg'),
            "title": "Announcement",
            "destPage": "/Announcement",
            "id": 22
        },
        {
            "imgSrc": require('../../assets/images/menu_roleManagement_default.svg'),
            "hoverImgSrc": require('../../assets/images/menu_roleManagement_hoverActive.svg'),
            "title": "Assign Role",
            "destPage": "/AssignRole",
            "id": 12
        },
        // {
        //     "imgSrc": require('../../assets/images/menu_cancellationPolicy_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_cancellationPolicy_hoverActive.svg'),
        //     "title": "Cancellation Policy",
        //     "destPage": "/CancellationPolicy",
        //     "id": 24
        // },
        {
            "imgSrc": require('../../assets/images/menu_createRole_default.svg'),
            "hoverImgSrc": require('../../assets/images/menu_createRole_hoverActive.svg'),
            "title": "Create Role",
            "destPage": "/Role",
            "id": 13
        },
        // {
        //     "imgSrc": require('../../assets/images/menu_manageServices_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_manageServices_hoverActive.svg'),
        //     "title": "Manage Services",
        //     "destPage": "/ManageServices",
        //     "id": 27
        // },
        // {
        //     "imgSrc": require('../../assets/images/menu_preAdvise_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_preAdvise_hoverActive.svg'),
        //     "title": "Pre-advise",
        //     "destPage": "/PreAdvice",
        //     "id": 11
        // },
        // {
        //     "imgSrc": require('../../assets/images/menu_subscriptionFees_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_subscriptionFees_hoverAtive.svg'),
        //     "title": "Subscription Fees",
        //     "destPage": "/SubscriptionFees",
        //     "id": 19
        // },
        {
            "imgSrc": require('../../assets/images/systemConfig_hoverActive.svg'),
            "hoverImgSrc": require('../../assets/images/systemConfig_default.svg'),
            "title": "System Config",
            "destPage": "/SystemConfig",
            "id": 1
        },
        {
            "imgSrc": require('../../assets/images/menu_terms&conditions_default.svg'),
            "hoverImgSrc": require('../../assets/images/menu_terms&conditions_hoverActive.svg'),
            "title": "Terms & Conditions",
            "destPage": "/TermConditions",
            "id": 16
        },
        // {
        //     "imgSrc": require('../../assets/images/menu_transactionDiscount_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_transactionDiscount_hoverActive.svg'),
        //     "title": "Transaction Discount",
        //     "destPage": "/TransactionFeesDiscount",
        //     "id": 17
        // },
        // {
        //     "imgSrc": require('../../assets/images/menu_transactionFees_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_transactionFees_hoverActive.svg'),
        //     "title": "Transaction Fees",
        //     "destPage": "/TransactionFees",
        //     "id": 18
        // },
        // {
        //     "imgSrc": require('../../assets/images/menu_userProfileApproval_default.svg'),
        //     "hoverImgSrc": require('../../assets/images/menu_userProfileApproval_hoverActive.svg'),
        //     "title": "User Profile Approval",
        //     "destPage": "/UserProfile",
        //     "id": 14
        // }

    ]
    const SystemConfigData = [
        {
            "title": "Maintain Facility",
            "destPage": "/MaintainFacility"
        },
        {
            "title": "Maintain Function",
            "destPage": "/MaintainFunction"
        },
        {
            "title": "Maintain Lookup",
            "destPage": "/MaintainLookup"
        }
    ]
    useEffect(() => {
        const pathname = window.location.hash;
        if (pathname == "#/MaintainFacility" || pathname == "#/MaintainFunction" || pathname == "#/MaintainLookup") {
            setIsSystemConfig(true)
        }
        else {
            setIsSystemConfig(false)
        }
    }, [])
    let selectedTiles = [];
    // SHOWING THROUGH LOGIN DATA
    const roleAssign = useSelector(state => JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    // const roleAssign = JSON.parse(AES.decrypt(Cookies.get('TPT_CARGO_CONNECT1_dev'),'TPT_CARGO_CONNECT').toString(enc.Utf8))
    const isSuperAdmin = roleAssign.userDetails.isSuperAdmin;
    // const role = roleAssign.userDetails.roles.length;
    // // if(role>0 )
    // // {
    // //   var assigntile= roleAssign.userDetails.roles[0].permissions
    // // }
    // // const role = useSelector(state => state.authentication.user.userDetails.roles.length);
    // if (role > 0) {
    //     // const tiles = localStorage.getItem('permission');
    //     // let assigntile = eval(tiles);
    //     tile.map((val, key) => {
    //         for (let c = 0; c < role; c++) {
    //             var assigntile = roleAssign.userDetails.roles[c].permissions
    //             assigntile.find((x, i) => {
    //                 if (val.id == x.functionId) {
    //                     if (x.method.length > 0) {
    //                         selectedTiles.push({
    //                             imgSrc: val.imgSrc,
    //                             hoverImgSrc: val.hoverImgSrc,
    //                             title: x.functionDisplayName,
    //                             destPage: val.destPage,
    //                         });
    //                     }
    //                 }
    //             })
    //         }
    //     })
    // }
    // SHOWING THROUGH ROLE DATA
    const roleData = useSelector(state=>state.adminRoleReducer.roleData)
  if(roleData != undefined){
  const roleDataLength = roleData.length;
//   var sampleArr = [];
  if (roleDataLength > 0) {
    tile.map((val,key)=>{
      for (let index = 0; index < roleData.length; index++) {
        let assigntile = roleData[index].permissions;

        assigntile.find((functions,i)=>{
          
          if (val.id == functions.functionId) {
              selectedTiles.push({
                imgSrc: val.imgSrc,
                hoverImgSrc: val.hoverImgSrc,
                title: functions.functionDisplayName,
                destPage: val.destPage,
                id: functions.functionId
              })
          }
        })
      }
      // BOTH ARE WORKING 
      
      // var xyz = selectedTiles.filter(function(x){
      //   if(sampleArr.indexOf(x.functionId == -1)){
      //     sampleArr.push(x.functionId)
      //     return true
      //   }
      //   return false
      // })
      selectedTiles = selectedTiles.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    })
  }
}
    return (
        <div class="sidenav">
            <div className="sideNavContainer">
                <NavLink exact to="/" className="active" activeClassName="main-active">
                    <div class="hov">
                        <div class="crd">
                            <img src={require('../../assets/images/menu_home_default.svg')} alt="" />
                            <img src={require('../../assets/images/menu_home_hoverActive.svg')} class="img-top" alt="" />
                        </div>
                        <h7 class="pl-3" id="title">Home</h7>
                    </div>
                </NavLink>
                <hr id="sidenavhr" />
                <div className="tileNameOuterDiv">
                    {
                        isSuperAdmin == true ? tile.map((name, index) => {
                            return (name.title !== "System Config") ? <NavLink exact to={name.destPage} className="active" activeClassName="main-active" >
                                <div class="hov">
                                    <div class="crd">
                                        <img src={name.imgSrc} alt="" />
                                        <img src={name.hoverImgSrc} class="img-top" alt="" />
                                    </div>
                                    <h7 class="pl-3" id="title">{name.title}</h7>
                                </div>
                            </NavLink>
                                :
                                <div>
                                    <NavLink exact to={name.destPage} className={isSystemConfig ? "main-active" : 'active'} activeClassName="main-active"
                                    >
                                        <div class="hov" id="SystemConfigSidehov">
                                            <div class="crd">
                                                <img src={name.imgSrc} alt="" />
                                                <img src={name.hoverImgSrc} class="img-top" alt="" />
                                            </div>
                                            <div class="SystemConfigSideTextDiv">
                                                <h7 class="pl-3 pt-1" id="title">{name.title}</h7>
                                            </div>
                                            <div class="crd" >
                                                <img src={require('../../assets/images/arrowUp_default.svg')} alt="" />
                                                <img src={require('../../assets/images/arrowUp_hoverActive.svg')}

                                                    class="img-top"
                                                    id="sideNavArrowHover"
                                                    alt="" />
                                            </div>
                                        </div>
                                    </NavLink>
                                    {(systemConfigdrop) &&
                                        <div class="systemConfigTopDiv">
                                            {(SystemConfigData.map((namedrop) => {
                                                return (
                                                    <NavLink exact to={namedrop.destPage} className="active" activeClassName="main-active" id="systemConfigSideNav" >
                                                        <div
                                                            id="SystemConfigSidehov">
                                                            <div class="SystemConfigSideTextDiv">
                                                                <h5 class="sideNavSystemConfigTitle" id="titleSystemConfig">{namedrop.title}</h5>
                                                            </div>
                                                        </div>
                                                    </NavLink>
                                                );
                                            }))
                                            }
                                        </div>}
                                </div>
                        })
                            :
                            selectedTiles.map((name, index) => {
                                return (name.title !== "System Config") ? <NavLink exact to={name.destPage} className="active" activeClassName="main-active" >
                                    <div class="hov">
                                        <div class="crd">
                                            <img src={name.imgSrc} alt="" />
                                            <img src={name.hoverImgSrc} class="img-top" alt="" />
                                        </div>
                                        <h7 class="pl-3" id="title">{name.title}</h7>
                                    </div>
                                </NavLink>
                                    :
                                    <div>
                                        <NavLink exact to={name.destPage} className={isSystemConfig ? "main-active" : 'active'} activeClassName="main-active"
                                        >
                                            <div class="hov" id="SystemConfigSidehov">
                                                <div class="crd">
                                                    <img src={name.imgSrc} alt="" />
                                                    <img src={name.hoverImgSrc} class="img-top" alt="" />
                                                </div>
                                                <div class="SystemConfigSideTextDiv">
                                                    <h7 class="pl-3 pt-1" id="title">{name.title}</h7>
                                                </div>
                                                <div class="crd" >
                                                    <img src={require('../../assets/images/arrowUp_default.svg')} alt="" />
                                                    <img src={require('../../assets/images/arrowUp_hoverActive.svg')}

                                                        class="img-top"
                                                        id="sideNavArrowHover"
                                                        alt="" />
                                                </div>
                                            </div>
                                        </NavLink>
                                        {(systemConfigdrop) &&
                                            <div class="systemConfigTopDiv">
                                                {(SystemConfigData.map((namedrop) => {
                                                    return (
                                                        <NavLink exact to={namedrop.destPage} className="active" activeClassName="main-active" id="systemConfigSideNav" >
                                                            <div
                                                                id="SystemConfigSidehov">
                                                                <div class="SystemConfigSideTextDiv">
                                                                    <h5 class="sideNavSystemConfigTitle" id="titleSystemConfig">{namedrop.title}</h5>
                                                                </div>
                                                            </div>
                                                        </NavLink>
                                                    );
                                                }))
                                                }
                                            </div>}
                                    </div>
                            })
                    }
                    {/* internal json file */}
                    {/* {
                    tile.map((name, index) =>{
                        return <NavLink exact to={name.destPage} className="active" activeClassName="main-active">
                        <div class="hov">
                            <div class="crd">
                                <img src={name.imgSrc} alt="" />
                                <img src={name.hoverImgSrc} class="img-top" alt="" />
                            </div>
                            <h7 class="pl-3" id="title">{name.title}</h7>
                        </div>
                    </NavLink>
                    })
                } */}
                </div>
            </div>
        </div>
    );
};
export default Sidenav;